<!--
 * @Author: maxwellllu
 * @Date: 2023-05-05 16:48:29
 * @LastEditors: maxwellllu
 * @LastEditTime: 2023-06-07 16:19:45
 * @FilePath: /privatization-webim/src/components/message-items/MsgGray/index.vue
 * @Description:
-->
<template>
  <div class="msg-gray">
    <gray-card
      v-if="hasExtuinInfo"
      :processedText="processedText"
      :text="text"
      :uin-info="uinInfo"
    ></gray-card>
    <span
      v-html="processedText"
      :class="device"
      ref="grayText"
      v-else
    ></span>
  </div>
</template>

<script>
import Utils from '@/utils/string';
import GrayCard from './gray-card.vue';
import globalWin from '@/utils/globalWin';


export default {
  components: {
    GrayCard,
  },
  props: {
    device: {
      type: String,
      default: 'pc',
    },
    data: Object,
  },
  computed: {
    text() {
      return this.data?.content?.gray;
    },
    uinInfo() {
      return this.data?.crm?.msg_webim_extra_data;
    },
    hasExtuinInfo() {
      /* eslint-disable max-len */
      return this.uinInfo?.str_avatar && this.uinInfo?.str_external_name;
    },
    processedText() {
      let text = this.data?.content?.gray || '';
      // 过滤html，保留a标签
      text = Utils.filterHTML(text);
      text = text.replace('\r\n', '<br>');
      return text;
    },
  },
  methods: {
    handleGrayLinkClick() {
      const textEl = this.$refs.grayText;
      if (textEl) {
        const linkEl = textEl.querySelectorAll('a');
        linkEl.forEach((item) => {
          item.addEventListener('click', () => {
            const type = item.getAttribute('data-type');
            switch (type) {
              // 切换语言
              case 'changeLang':
                globalWin.switchSetLangPanel(true);
            }
          });
        });
      }
    },
  },
  mounted() {
    // 处理a链接点击事件
    this.handleGrayLinkClick();
  },
};
</script>

<style lang="less" scoped>
.msg-gray {
  font-size: 12px;
  text-align: center;
  line-height: 20px;
  span {
    border-radius: 12px;
    padding: 2px 12px;
    display: inline-block;
    color: #B4B8C4;
    &.pc {
      background: #eceef1;
    }
    &.h5 {
      border-radius: 6px;
      background: #fff;
    }
  }
}
</style>
